import { Button, Card, CardBody, CardFooter, CardHeader, Center, Image } from "@chakra-ui/react"
import { faCheck } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { MediaMeta } from "@xnav/types/src/common"
import { useState } from "react"
import { matchMediaIcon } from "@/functions/mediaFunctions"

const MediaSingleSelectionCard: React.FC<{
    data: MediaMeta,
    onSelect: (media: MediaMeta) => void
}> = ({ data, onSelect }) => {
    const [confirmSelection, setConfirmSelection] = useState<boolean>(false)

    return (
        <Card h={300} flex={1} flexDir='column'>
            <CardHeader as='b' display='flex' gap={3} alignItems='center'>
                <FontAwesomeIcon icon={matchMediaIcon(data.type)} />
                {data.name}
            </CardHeader>
            <CardBody flex={1} display='flex' justifyContent='center' alignItems='center' minH={0}>
                {data.type === 'audio' || data.type === 'pdf' ? (
                    <Center flex={1} w='full'><FontAwesomeIcon icon={matchMediaIcon(data.type)} opacity={.5} size='5x' /></Center>
                ) : (
                    <Image src={data.iconUrl} fit='contain' w='full' h='100%' />
                )}
            </CardBody>
            <CardFooter>
                <Center w='full' gap={3}>
                    {confirmSelection ? (
                        <Button flex={1} variant='outline' colorScheme='green' leftIcon={<FontAwesomeIcon icon={faCheck} />} onClick={() => onSelect(data)}>Confirm</Button>
                    ) : (
                        <Button flex={1} leftIcon={<FontAwesomeIcon icon={faCheck} />} onClick={() => setConfirmSelection(true)}>Select</Button>
                    )}
                </Center>
            </CardFooter>
        </Card>
    )
}

export default MediaSingleSelectionCard
